<div *ngIf="datosform" class="main-content profile-editor-page client-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ tituloOperacion }} de Cliente</h1>
        <p>{{ operationDescription }}</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="onNoClick()">
          Regresar
        </button>
        <button type="button" class="app-form-btn app-form-btn--primary" (click)="saveClient()"
          [disabled]="datosform.invalid || isSaving">
          Guardar cliente
        </button>
      </div>
    </section>

    <div class="row profile-editor-page__layout client-editor-page__layout">
      <div class="col-xl-8 col-lg-7">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header">
            <div class="client-editor-page__card-copy">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">business</i>
                <span>Datos del Cliente</span>
              </div>
              <span>Capture la información principal, datos de contacto y la clave interna del cliente.</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <form [formGroup]="datosform" class="client-editor-page__form">
              <div class="row client-editor-page__grid">
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Razón social</mat-label>
                    <input matInput aria-label="Razón social" type="text" maxlength="50" formControlName="rSocial"
                      [(ngModel)]="client.razonsocial" />
                    <mat-error *ngIf="datosform.controls.rSocial.touched && datosform.controls.rSocial.invalid">
                      Capture la razón social.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-3" *ngIf="!esProspectoRfc">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>RFC</mat-label>
                    <input matInput aria-label="RFC" type="text" maxlength="13" onkeyup="this.value=this.value.toUpperCase();"
                      formControlName="rfc" [(ngModel)]="client.rfc" />
                    <mat-error
                      *ngIf="datosform.controls.rfc.invalid && (datosform.controls.rfc.dirty || datosform.controls.rfc.touched)">
                      <small *ngIf="datosform.controls.rfc.errors?.required">El campo es requerido.</small>
                      <small *ngIf="datosform.controls.rfc.errors?.pattern">El RFC es inválido.</small>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-3">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Nombre corto</mat-label>
                    <input matInput aria-label="Nombre corto" type="text" maxlength="50" formControlName="nombre_corto" [readonly]="isEditMode"
                      [(ngModel)]="client.nombre_corto" />
                    <mat-error
                      *ngIf="datosform.controls.nombre_corto.touched && datosform.controls.nombre_corto.errors?.pattern">
                      Solo se permiten letras y números, sin espacios.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-4" *ngIf="!esProspectoRepresentante">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Representante</mat-label>
                    <input notCopyPaste matInput aria-label="Representante" type="text" maxlength="50" formControlName="represent"
                      [(ngModel)]="client.representante" />
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Correo</mat-label>
                    <input matInput aria-label="Correo" type="text" maxlength="50" formControlName="email" [(ngModel)]="client.email" />
                    <mat-error *ngIf="datosform.controls.email.touched && datosform.controls.email.invalid">
                      Capture un correo válido.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-2">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Teléfono</mat-label>
                    <input matInput aria-label="Teléfono" type="text" maxlength="10"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57" pattern="^(\d{10}|\d{13})$"
                      formControlName="tel" [(ngModel)]="client.telefono" />
                    <mat-error
                      *ngIf="datosform.controls.tel.invalid && (datosform.controls.tel.dirty || datosform.controls.tel.touched)">
                      <small *ngIf="datosform.controls.tel.errors?.required">El campo es requerido.</small>
                      <small *ngIf="datosform.controls.tel.errors?.pattern">El teléfono es inválido.</small>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-2">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Ext. Tel.</mat-label>
                    <input soloNumeroEntero matInput aria-label="Ext. Tel." type="text" maxlength="3" formControlName="extensionTel"
                      [(ngModel)]="client.extensionTel" />
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Nombre de contacto</mat-label>
                    <input matInput aria-label="Nombre de contacto" type="text" maxlength="50" formControlName="nombreContacto"
                      [(ngModel)]="client.nombreContacto" />
                    <mat-error
                      *ngIf="datosform.controls.nombreContacto.touched && datosform.controls.nombreContacto.invalid">
                      Capture el nombre de contacto.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Forma de contacto</mat-label>
                    <input matInput aria-label="Forma de contacto" type="text" maxlength="50" formControlName="forma"
                      [(ngModel)]="client.formacontacto" />
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Clave del cliente</mat-label>
                    <input matInput aria-label="Clave del cliente" type="text" maxlength="3" style="text-transform: uppercase"
                      formControlName="idProyecto" [(ngModel)]="client.idProyecto" />
                    <mat-error *ngIf="datosform.controls.idProyecto.touched && datosform.controls.idProyecto.invalid">
                      Capture la clave del cliente.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>

      <div class="col-xl-4 col-lg-5">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header">
            <div class="client-editor-page__card-copy">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">tune</i>
                <span>Clasificación Comercial</span>
              </div>
              <span>Configure tipo, segmento, tamaño y la condición de prospecto del cliente.</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <form [formGroup]="datosform" class="client-editor-page__form">
              <div class="row client-editor-page__grid">
                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Tipo de cliente</mat-label>
                    <mat-select [(ngModel)]="client.idtipo" formControlName="tipo">
                      <mat-option *ngFor="let tipoObject of listTipos" [value]="tipoObject.id">
                        {{ tipoObject.tipo }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Segmento de cliente</mat-label>
                    <mat-select [(ngModel)]="client.idsegmento" formControlName="segmento">
                      <mat-option *ngFor="let segmentoObject of listSegmentos" [value]="segmentoObject.id">
                        {{ segmentoObject.segmento }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline" class="profile-editor-page__field">
                    <mat-label>Tamaño de cliente</mat-label>
                    <mat-select [(ngModel)]="client.idtamanio" formControlName="tam">
                      <mat-option *ngFor="let tamObject of listTamanios" [value]="tamObject.id">
                        {{ tamObject.de }} al {{ tamObject.al }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <div class="client-editor-page__radio-card">
                    <div class="client-editor-page__radio-copy">
                      <strong>¿Es prospecto?</strong>
                      <span>Defina si el cliente está en fase comercial o ya es una cuenta formal.</span>
                    </div>
                    <mat-radio-group class="client-editor-page__radio-group" [(ngModel)]="client.esProspecto"
                      name="esProspecto" formControlName="esProspecto" (change)="onRadioCompromisoChange()">
                      <mat-radio-button [value]="1">Sí</mat-radio-button>
                      <mat-radio-button [value]="0">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>

                <div class="col-12">
                  <mat-form-field appearance="outline"
                    class="profile-editor-page__field client-editor-page__textarea-field">
                    <mat-label>Referencia</mat-label>
                    <textarea matInput aria-label="Referencia" rows="5" maxlength="500" formControlName="ref"
                      [(ngModel)]="client.comentarios"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </form>

            <div class="client-editor-page__summary">
              <span class="client-editor-page__summary-label">Cliente</span>
              <strong>{{ clientePreview }}</strong>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>